import find from "lodash/find";
import sortBy from "lodash/sortBy";
import {
  chineseSilver,
  whiteColor,
  whiteSmoke,
} from "../../../../../common/helpers/colors";

const getEnchancedRules = (config) => {
  const { acmgRules, classifications } = config;

  if (acmgRules) {
    const rules = acmgRules.map((r) => {
      const rule = find(classifications, { name: r.name });

      return {
        ...r,
        ...(rule && { user_explain: rule.user_explain }),
      };
    });

    const classificationMap = classifications?.map((c) => c.name);
    // we sort the rules by the order of the classifications
    const sortedRules = classificationMap
      ? sortBy(rules, (item) => classificationMap.indexOf(item.name))
      : rules;

    return sortedRules;
  }

  return null;
};

const customStyles = {
  container: (base) => ({
    ...base,
    width: "100%",
    maxWidth: "650px",
    display: "inline-block",
    position: "relative",
    borderColor: chineseSilver,
  }),
  menu: (base) => ({
    ...base,
    borderColor: chineseSilver,
    marginTop: "-1px",
    textAlign: "left",
    zIndex: 9999,
  }),
  control: (base) => ({
    ...base,
    borderRadius: "0px",
    border: "1px solid #cccccc",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #cccccc",
    },
  }),
  option: (provided, optionState) => ({
    ...provided,
    color: optionState.isSelected ? "black" : "black",
    ...(optionState.isSelected && {
      backgroundColor: "#e5e5e5",
    }),
    ...(!optionState.isSelected && {
      backgroundColor: optionState.isFocused ? whiteSmoke : whiteColor,
    }),
    "&:active": {
      backgroundColor: whiteSmoke,
    },
  }),
};

const getAllActiveRulesStrengths = (
  activeOverrideStrengths,
  rulesThatMetCriteria
) => {
  const rulesThatMetCriteriaObj = {};

  rulesThatMetCriteria.forEach((rule) => {
    rulesThatMetCriteriaObj[rule.name] =
      rule.acmg_triggered_strength || rule.strength;
  });
  return {
    ...rulesThatMetCriteriaObj,
    ...activeOverrideStrengths,
  };
};

const getInitialRulesStrength = (rulesThatMetCriteria) => {
  const rulesThatMetCriteriaObj = {};

  rulesThatMetCriteria?.forEach((rule) => {
    rulesThatMetCriteriaObj[rule.name] =
      rule.acmg_triggered_strength || rule.strength;
  });
  return {
    ...rulesThatMetCriteriaObj,
  };
};

// TODO: good candidate for unit testing
const createRuleParams = (
  acmgRules,
  rulesThatMetCriteria,
  activeOverrideStrengths,
  pillsToggleState
) => {
  if (!acmgRules) return null;
  const strengthParams = {
    "Stand Alone": "StandAlone",
    "Very Strong": "VeryStrong",
    Strong: "Strong",
    Moderate: "Moderate",
    Supporting: "Supporting",
  };
  const initialStrengthList = {};
  const activeDefaultList = {};
  const triggeredStrengthList = {};

  acmgRules.forEach((rule) => {
    initialStrengthList[rule.name] = rule.strength;
  });
  rulesThatMetCriteria.forEach((rule) => {
    activeDefaultList[rule.name] =
      rule.acmg_triggered_strength || rule.strength;
    triggeredStrengthList[rule.name] = rule.acmg_triggered_strength;
  });

  const activeStrengths = getAllActiveRulesStrengths(
    activeOverrideStrengths,
    rulesThatMetCriteria
  );

  let params = "";

  Object.keys(activeStrengths).forEach((k) => {
    const name = k;
    const strength = activeStrengths[k];
    const addAmpersand = params === "" ? "" : "&";

    // if the pills state is in the list and it is false then skip
    if (
      pillsToggleState[name] !== undefined &&
      pillsToggleState[name] === false
    ) {
      return;
    }

    // add the strength when it ovverides the default strength
    // always send the acmg triggered strength
    if (
      (!activeDefaultList[name] && initialStrengthList[name] !== strength) ||
      (activeDefaultList[name] &&
        activeDefaultList[name] !== strength &&
        initialStrengthList[name] !== strength) ||
      (triggeredStrengthList[name] === strength &&
        initialStrengthList[name] !== strength)
    ) {
      params += `${addAmpersand}rules=${name}_${strengthParams[strength]}`;
    } else {
      params += `${addAmpersand}rules=${name}`;
    }
  });

  return params;
};

const checkResetedRules = (
  pillsToggleState,
  activeRulesList,
  rulesThatMetCriteria,
  activeOverrideStrengths
) => {
  let resetedRules = true;
  let resetStrentgh = true;
  for (const [key, value] of Object.entries(pillsToggleState)) {
    const found = activeRulesList.find((i) => i.name === key);
    const isRuleInitialState = found.isActive !== value;
    if (isRuleInitialState) {
      resetedRules = false;
      break;
    }
  }
  const initialRulesStrenghts = getInitialRulesStrength(rulesThatMetCriteria);

  for (const [key, value] of Object.entries(activeOverrideStrengths)) {
    if (
      typeof initialRulesStrenghts[key] !== "undefined" &&
      initialRulesStrenghts[key] !== value
    ) {
      resetStrentgh = false;
      break;
    }
  }
  const rulesAreResetedtoOriginalValues = resetedRules && resetStrentgh;
  return rulesAreResetedtoOriginalValues;
};

export {
  getEnchancedRules,
  customStyles,
  getAllActiveRulesStrengths,
  getInitialRulesStrength,
  createRuleParams,
  checkResetedRules,
};
